<template>
  <div
    class="ys-float-btn"
    :style="{
      width: itemWidth + 'px',
      height: itemHeight + 'px',
      left: left + 'px',
      top: top + 'px'
    }"
    ref="div"
    @click="onBtnClicked"
    @mouseover="hoverListener"
    @mouseout="mouseoutListener"
  >
    <v-icon>mdi-settings</v-icon>
  </div>
</template>

<script>
export default {
  name: "FloatImgBtn",
  props: {
    text: {
      type: String,
      default: ""
    },
    itemWidth: {
      type: Number,
      default: 60
    },
    menuOpen: {
      type: Boolean,
      default: false
    },
    itemHeight: {
      type: Number,
      default: 60
    },
    gapWidth: {
      type: Number,
      default: 0
    },
    coefficientHeight: {
      type: Number,
      default: 0.8
    }
  },
  data() {
    return {
      timer: null,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      left: 0,
      top: 0
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = 0 - this.itemWidth / 2;
    this.top = 150;
  },
  mounted() {
    this.$nextTick(() => {
      const div = this.$refs.div;
      div.addEventListener("touchstart", () => {
        div.style.transition = "none";
      });
      div.addEventListener("touchmove", e => {
        if (e.targetTouches.length === 1) {
          e.preventDefault();
          e.stopPropagation();
          let touch = event.targetTouches[0];
          this.left = touch.clientX - this.itemWidth / 2;
          this.top = touch.clientY - this.itemHeight / 2;
        }
      });
      div.addEventListener("touchend", () => {
        div.style.transition = "all 0.3s";
        this.relocateFab();
      });
    });
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.relocateFab(), 500);
    });
  },
  beforeDestroy() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.relocateFab(), 500);
    });
  },
  methods: {
    hoverListener() {
      this.left =
        this.left > this.clientWidth / 2
          ? this.clientWidth - this.itemWidth
          : 0;
    },
    mouseoutListener() {
      if (this.menuOpen) {
        return;
      }
      this.left =
        this.left > this.clientWidth / 2
          ? this.clientWidth - this.itemWidth / 2
          : 0 - this.itemWidth / 2;
    },
    relocateFab() {
      this.clientHeight = document.documentElement.clientHeight;
      this.clientWidth = document.documentElement.clientWidth;
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth / 2;
      } else {
        this.left = 0 - this.itemWidth / 2;
      }
      if (this.top > this.clientHeight - this.itemHeight / 2) {
        this.top = this.clientHeight - this.itemHeight / 2;
      } else if (this.top < this.itemHeight / 2) {
        this.top = this.itemHeight / 2;
      }
    },
    onBtnClicked() {
      this.left =
        this.left > this.clientWidth / 2
          ? this.clientWidth - this.itemWidth
          : 0;
      this.$emit("onFloatBtnClicked", {
        goal: "OpenThemeMenu",
        data: true
      });
    },
    hiddenFab() {
      this.left =
        this.left > this.clientWidth / 2
          ? this.clientWidth - this.itemWidth / 2
          : 0 - this.itemWidth / 2;
    }
  }
};
</script>

<style scoped>
.ys-float-btn {
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  color: #666666;
  z-index: 20;
  transition: all 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: fixed;
  bottom: 20vw;

  img {
    width: 50%;
    height: 50%;
    object-fit: contain;
    margin-bottom: 3px;
  }

  p {
    font-size: 7px;
  }
}
</style>
